"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Utility_1 = require("../Utility");
var List = function (props) {
    var _a = (0, Utility_1.handleUtility)(props), card = _a.card, className = _a.className, secondary = _a.secondary, arrow = _a.arrow, _b = _a.rows, rows = _b === void 0 ? [] : _b, onClick = _a.onClick, rest = __rest(_a, ["card", "className", "secondary", "arrow", "rows", "onClick"]);
    var classes = (0, classnames_1.default)(className, {
        't2-simple': !secondary && !card,
        't2-secondary': secondary,
        't2-card': card,
        't2-clickable': onClick,
        't2-arrow': onClick && arrow,
    });
    return rows.length ? (react_1.default.createElement("ul", __assign({ role: 'listbox', className: classes }, rest), rows.map(function (row, i) { return (react_1.default.createElement("li", { role: 'option', key: i, onClick: onClick ? function (e) { return onClick(row, i, e); } : undefined }, row)); }))) : null;
};
exports.default = List;
